var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoStartover = function SvgIcoStartover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M4.934 19.071c3.905 3.905 10.237 3.905 14.142 0s3.905-10.237 0-14.142c-3.596-3.596-9.248-3.88-13.17-.856l-.901-.901a.5.5 0 0 0-.849.282l-.471 3.3a.5.5 0 0 0 .566.566l3.3-.471A.5.5 0 0 0 7.832 6l-.497-.498a8 8 0 1 1-.988 12.154 1 1 0 1 0-1.414 1.415m5.652-3.222 4.913-2.966a1.028 1.028 0 0 0 0-1.765L10.587 8.15A1.05 1.05 0 0 0 10.043 8C9.467 8 9 8.463 9 9.034v5.932c0 .19.053.376.152.538.3.488.942.642 1.434.345",
    clipRule: "evenodd"
  })));
};
export default SvgIcoStartover;